import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledDialogLayout = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background: ${COLOR.white};
  display: flex;
  flex-direction: column;
  align-items: center;

  .dialog-inner {
    position: relative;
    width: 100%;
    max-width: 880px;
    padding-top: 80px;
    padding-bottom: 40px;
  }

  .dialog-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
  }

  .dialog-content {
    padding: 0 80px;
  }

  .dialog-close-button {
    position: fixed;
    top: 40px;
    right: 40px;
    width: 40px;
    height: 40px;
    border: 1px solid ${COLOR.indigo[32]};
    border-radius: 12px;
    background: ${COLOR.white};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;

    &:hover {
      background: ${COLOR.indigo[4]};
    }
  }

  @media (max-width: 768px) {
    .dialog-inner {
      max-width: 100%;
      padding-top: 60px;
    }

    .dialog-content {
      padding: 0 24px;
    }

    .dialog-close-button {
      top: 12px;
      right: 16px;
    }

    .dialog-logo {
      margin-bottom: 32px;
    }
  }
`;
